import React, { useRef, useState } from 'react';
import { DatePicker } from '@mantine/dates';
import { Popover } from '@mui/material';

import { dayjs } from '../../../../../../utils/dayjs-utils';
import InputComponent from '../../../../../common-components/InputComponent/InputComponent';
import DateOutline from '../../../../../Icons/icons/DateOutline';

export default function CustomDatePickerInput({
  date,
  setDate,
  label,
  required,
  placeholder,
  minDate,
  disabled,
  maxDate,
  showLabel = true,
  color = '#616161',
  dateFormat = 'DD-MM-YYYY',
  popoverPosition = {
    anchorOrigin: { vertical: 'center', horizontal: 'left' },
    transformOrigin: { vertical: 'center', horizontal: 'right' },
  },
  inputClassName = '',
  right = <></>,
  inputWrapperClass = '',
}) {
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const datePickerRef = useRef();

  const openDatePicker = () => {
    if (disabled) return;
    if (!isDatePickerOpen) setIsDatePickerOpen(true);
  };

  return (
    <div ref={datePickerRef}>
      <InputComponent
        label={showLabel && (label || 'Select Date')}
        placeholder={placeholder}
        required={required}
        readOnly
        inputWrapperStyle={{ borderColor: isDatePickerOpen && 'var(--border-highlight)' }}
        value={date ? dayjs(date).format(dateFormat) : ''}
        onFocus={(e) => {
          openDatePicker();
          e.target?.blur();
        }}
        inputClassName={inputClassName}
        inputWrapperClass={inputWrapperClass}
        left={
          <DateOutline
            onClick={() => {
              openDatePicker();
            }}
            style={{ cursor: 'pointer' }}
            color={color}
          />
        }
        right={right}
      />

      <Popover
        anchorEl={datePickerRef?.current}
        open={isDatePickerOpen}
        onClose={() => {
          setIsDatePickerOpen(false);
        }}
        anchorOrigin={popoverPosition.anchorOrigin}
        transformOrigin={popoverPosition.transformOrigin}>
        <div className="custom-date-picker-container">
          <DatePicker
            allowDeselect={false}
            value={date || null}
            minDate={minDate}
            maxDate={maxDate}
            setDate={setDate}
            styles={{
              day: {
                '&[data-selected], &[data-selected]:hover': {
                  borderRadius: '50%',
                },
              },
            }}
            onChange={(v) => {
              setDate(v);
              setIsDatePickerOpen(false);
            }}
          />
        </div>
      </Popover>
    </div>
  );
}
